import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { LayoutService } from './layout/layout.service';

// 3rd
// import 'styles/nyvus3-material-theme.scss';
import 'styles/bootstrap.scss';
// custom
import 'styles/layout.scss';
import 'styles/theme.scss';
import 'styles/ui.scss';
import 'styles/app.scss';
import { Subscription } from 'rxjs';
import { Loading } from './_models/shared/loading';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	providers: [LayoutService]
})
export class AppComponent implements OnInit {
	constructor(private router: Router) {}
	routerEventsSubscription: Subscription;
	cargandoModulo: Loading = new Loading();
	ngOnInit() {
		this.routerEventsSubscription = this.router.events.pipe().subscribe(evt => {
			if (evt instanceof NavigationStart) {
				this.cargandoModulo.begin();
			}
			if (evt instanceof NavigationEnd) {
				if (evt) {
					this.cargandoModulo.finish();
				}
			}
			if (!(evt instanceof NavigationEnd)) {
				return;
			}
			window.scrollTo(0, 0);
		});
	}
}
